import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiInstagram, FiLinkedin, FiTwitter, FiFacebook, FiYoutube, FiVideo, FiBarChart2, FiCalendar } = FiIcons;

const HeroVisual = () => {
  return (
    <div className="relative max-w-5xl mx-auto h-[400px] md:h-[600px] perspective-1000">
      {/* Central Dashboard - Isometric tilt */}
      <motion.div
        initial={{ rotateX: 20, rotateY: 0, opacity: 0 }}
        animate={{ rotateX: 10, rotateY: 0, opacity: 1 }}
        transition={{ duration: 1, type: "spring" }}
        className="w-full h-full bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden relative z-10 transform-style-3d shadow-brand-teal/20"
      >
        {/* Dashboard Header */}
        <div className="h-14 bg-white border-b border-gray-100 flex items-center px-6 justify-between">
          <div className="flex space-x-2">
            <div className="w-3 h-3 rounded-full bg-red-400"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
            <div className="w-3 h-3 rounded-full bg-green-400"></div>
          </div>
          <div className="w-1/3 h-2 bg-gray-100 rounded-full"></div>
          <div className="w-8 h-8 rounded-full bg-gray-100"></div>
        </div>

        {/* Dashboard Body */}
        <div className="flex h-full">
          {/* Sidebar */}
          <div className="w-20 bg-gray-50 border-r border-gray-100 p-4 flex flex-col items-center gap-6 pt-8">
            <div className="w-10 h-10 rounded-lg bg-brand-teal/10 flex items-center justify-center text-brand-teal">
              <SafeIcon icon={FiCalendar} />
            </div>
            <div className="w-10 h-10 rounded-lg bg-transparent flex items-center justify-center text-gray-400">
              <SafeIcon icon={FiBarChart2} />
            </div>
            <div className="w-10 h-10 rounded-lg bg-transparent flex items-center justify-center text-gray-400">
              <SafeIcon icon={FiVideo} />
            </div>
          </div>

          {/* Main Content Area */}
          <div className="flex-1 p-8 bg-gray-50/50">
            <div className="flex justify-between items-center mb-8">
              <div>
                <div className="h-6 w-48 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-32 bg-gray-100 rounded"></div>
              </div>
              <div className="px-4 py-2 bg-brand-teal text-white rounded-lg text-sm font-medium">Create Post</div>
            </div>

            {/* Calendar Grid Simulation */}
            <div className="grid grid-cols-4 gap-4">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 h-40 flex flex-col justify-between group hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-bold text-gray-400">{i + 12}</div>
                    <div className="flex -space-x-2">
                       <div className="w-6 h-6 rounded-full bg-pink-100 border-2 border-white flex items-center justify-center text-pink-600 text-[10px]"><SafeIcon icon={FiInstagram} /></div>
                       <div className="w-6 h-6 rounded-full bg-blue-100 border-2 border-white flex items-center justify-center text-blue-600 text-[10px]"><SafeIcon icon={FiLinkedin} /></div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="h-2 w-full bg-gray-100 rounded"></div>
                    <div className="h-2 w-2/3 bg-gray-100 rounded"></div>
                  </div>
                  <div className="text-[10px] text-gray-400 font-medium bg-gray-50 self-start px-2 py-1 rounded">09:00 AM</div>
                </div>
              ))}
            </div>

            {/* Analytics Preview */}
            <div className="mt-8 grid grid-cols-2 gap-6">
               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                 <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-brand-cyan/10 flex items-center justify-center text-brand-cyan">
                      <SafeIcon icon={FiBarChart2} />
                    </div>
                    <div>
                      <div className="text-sm text-gray-500">Total Reach</div>
                      <div className="text-xl font-bold text-brand-navy">24.5K <span className="text-green-500 text-xs">+12%</span></div>
                    </div>
                 </div>
                 <div className="h-24 flex items-end justify-between gap-2">
                    {[40, 60, 45, 70, 50, 80, 65].map((h, i) => (
                      <div key={i} className="w-full bg-brand-teal/20 rounded-t-sm hover:bg-brand-teal/40 transition-colors" style={{ height: `${h}%` }}></div>
                    ))}
                 </div>
               </div>
               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-center items-center text-center">
                  <div className="w-16 h-16 rounded-full bg-brand-yellow/20 flex items-center justify-center text-brand-yellow mb-3">
                    <SafeIcon icon={FiVideo} className="text-2xl" />
                  </div>
                  <div className="font-bold text-brand-navy">Viral Contest</div>
                  <div className="text-sm text-gray-500 mb-3">247 Entries</div>
                  <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div className="w-3/4 h-full bg-brand-yellow"></div>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Orbiting Icons */}
      <div className="absolute inset-0 pointer-events-none">
        {[
          { icon: FiInstagram, color: 'text-pink-600', bg: 'bg-white', pos: 'top-10 -left-10' },
          { icon: FiLinkedin, color: 'text-blue-700', bg: 'bg-white', pos: 'top-1/3 -right-16' },
          { icon: FiTwitter, color: 'text-sky-500', bg: 'bg-white', pos: 'bottom-20 -left-8' },
          { icon: FiFacebook, color: 'text-blue-600', bg: 'bg-white', pos: '-top-8 right-20' },
          { icon: FiYoutube, color: 'text-red-600', bg: 'bg-white', pos: 'bottom-1/3 -right-12' },
          { icon: FiVideo, color: 'text-black', bg: 'bg-white', pos: 'bottom-0 left-20' }
        ].map((item, i) => (
          <motion.div
            key={i}
            className={`absolute ${item.pos} w-16 h-16 rounded-2xl shadow-xl ${item.bg} flex items-center justify-center z-20 border border-gray-100`}
            animate={{ 
              y: [0, -15, 0],
              rotate: [0, 5, -5, 0]
            }}
            transition={{ 
              duration: 4 + i, 
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.5
            }}
          >
            <SafeIcon icon={item.icon} className={`text-3xl ${item.color}`} />
          </motion.div>
        ))}
      </div>
      
      {/* Connecting Lines (Simulated with absolute divs) */}
      <div className="absolute inset-0 z-0 opacity-30">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
           <path d="M20,20 Q50,50 50,50" stroke="#00D4AA" strokeWidth="0.5" fill="none" className="animate-pulse" />
           <path d="M80,30 Q50,50 50,50" stroke="#00D4AA" strokeWidth="0.5" fill="none" className="animate-pulse" />
           <path d="M20,80 Q50,50 50,50" stroke="#00D4AA" strokeWidth="0.5" fill="none" className="animate-pulse" />
           <path d="M80,70 Q50,50 50,50" stroke="#00D4AA" strokeWidth="0.5" fill="none" className="animate-pulse" />
        </svg>
      </div>
    </div>
  );
};

export default HeroVisual;